import { createContext } from 'react';

import type { StepFlowStepContext } from './types';

export const StepFlowContext = createContext<StepFlowStepContext | null>(null);
